import { Box } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { ICustomTablePaginationProps } from './types';
import MantisPagination from './MantisPagination';

export const CustomTablePagination: FC<ICustomTablePaginationProps> = ({
	totalRows,
	page,
	handleChangePage,
	rowsPerPage,
	handleChangeRowsPerPage,
	customComponent
}) => {
	const getRowsPerPageOptions = (): number[] => {
		if (totalRows <= 5) return [5];
		if (totalRows <= 10) return [5, 10];
		return [5, 10, 25, 50];
	};

	if (customComponent) {
		return <Box sx={{ p: 0, m: 0, width: '100%' }}>{customComponent}</Box>;
	}

	return (
		<MantisPagination
			count={totalRows}
			page={page}
			rowsPerPage={rowsPerPage}
			onPageChange={(p) => handleChangePage(null, p)}
			onRowsPerPageChange={(n) =>
				handleChangeRowsPerPage({ target: { value: String(n) } } as ChangeEvent<HTMLInputElement>)
			}
			rowsPerPageOptions={getRowsPerPageOptions()}
		/>
	);
};
